import { Box, Button, Card, Flex } from '@mantine/core'
import { modals } from '@mantine/modals'
import withErrorBoundaryAndPolicyCheck from '@v2/commons/HOC/ErrorBoundaryAndPolicyCheckHOC'
import EmptyPersons from '@v2/commons/components/EmptyBlock/EmptyPersons.component'
import SearchInput from '@v2/commons/components/SearchInput/SearchInput'

import { Icons } from 'src/common/components'
import { type TBreadCrumbItems } from 'src/v2/commons/components/Breadcrumb'
import InfiniteScrollTemplate from 'src/v2/commons/templates/InfiniteScrollTemplate'

import CreateTagModal from '../components/createTagModal/createTagModal.component'
import TagsListTable from '../components/tagsTableList/tagsListTable.component'
import useGetTags from '../hooks/useGetTag.hook'

const Table = withErrorBoundaryAndPolicyCheck(
  TagsListTable,
  'is_enable_tags_table',
  true,
)

const breadCrumbItems: TBreadCrumbItems = [
  { title: 'Home' },
  { title: 'Administration Panel' },
  { title: 'Tags' },
]

const TagsView = () => {
  const {
    isLoading,
    tags,
    searchTagForm,
    totalRecords,
    handlePaginate,
    resetPaginate,
  } = useGetTags()

  const handleCreateTag = () => {
    modals.open({
      centered: true,
      withCloseButton: true,
      size: 'md',
      children: <CreateTagModal onMutationSuccess={resetPaginate} />,
    })
  }

  return (
    <InfiniteScrollTemplate
      isLoading={isLoading}
      title={'Tags'}
      header={
        <Button
          variant="filled"
          leftSection={<Icons.Plus />}
          onClick={handleCreateTag}
        >
          Create New Tag
        </Button>
      }
      breadCrumbItems={breadCrumbItems}
      onScroll={handlePaginate}
      records={{
        totalRecords: totalRecords ?? 0,
        actualNumberOfRecords: tags?.length ?? 0,
      }}
    >
      <Card shadow="lg" radius="md" style={{ padding: '36px' }}>
        <Flex gap="xl" justify="space-between" align="center" mb="30px">
          <Box flex={1}>
            <SearchInput form={searchTagForm} />
          </Box>
        </Flex>
        {tags?.length > 0 && !isLoading ? (
          <Table
            tags={tags}
            isLoading={isLoading}
            resetPaginate={resetPaginate}
          />
        ) : (
          tags?.length === 0 && <EmptyPersons term="Tags" />
        )}
      </Card>
    </InfiniteScrollTemplate>
  )
}

export default TagsView
